// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";

//   React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

//   React context
import {useMaterialUIController} from "context";
import {Grid, Typography} from "@mui/material";
import properties from "constants/ApplicationConstants";
function Bill_Bank({details = {}, noGutter}) {
  const [controller] = useMaterialUIController();
  const {darkMode} = controller;

  return (
    <MDBox pt={1} pb={0} px={2}>
      <MDBox pt={3} px={2}>
        <Typography variant="h6" fontWeight="medium" fontFamily={properties.fontFamily}>
          Bank Details
        </Typography>
      </MDBox>
      <MDBox
        component="li"
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        bgColor={darkMode ? "transparent" : "grey-100"}
        borderRadius="lg"
        p={1}
        mb={noGutter ? 0 : 1}
        mt={1}
      >
        <MDBox width="100%" display="flex" flexDirection="column">
          <Grid container spacing={2} mb={2}>
            <Grid item xs={12} sm={6}>
              <MDBox display="flex" alignItems="center" gap={1}>
                <Typography variant="caption" color="text" fontFamily={properties.fontFamily}>
                  Bank Name :&nbsp;
                  <Typography
                    variant="caption"
                    fontWeight="medium"
                    fontFamily={properties.fontFamily}
                  >
                    {details ? details.bankName : "NA"}
                  </Typography>
                </Typography>
              </MDBox>
            </Grid>

            <Grid item xs={12} sm={6}>
              <MDBox display="flex" alignItems="center" gap={1}>
                <Typography
                  variant="caption"
                  color="text"
                  mr={2}
                  fontFamily={properties.fontFamily}
                >
                  Account no. :&nbsp;
                  <Typography
                    variant="outlined"
                    fontWeight="medium"
                    fontFamily={properties.fontFamily}
                  >
                    {details ? details.bankAcnumber : "NA"}
                  </Typography>
                </Typography>
              </MDBox>
            </Grid>
          </Grid>
          <Grid container spacing={2} mb={2}>
            <Grid item xs={12} sm={6}>
              <MDBox display="flex" alignItems="center" gap={1}>
                <Typography variant="caption" color="text" fontFamily={properties.fontFamily}>
                  Name in Bank :&nbsp;
                  <Typography
                    variant="caption"
                    fontWeight="medium"
                    fontFamily={properties.fontFamily}
                  >
                    {details ? details.nameInBank : "NA"}
                  </Typography>
                </Typography>
              </MDBox>
            </Grid>

            <Grid item xs={12} sm={6}>
              <MDBox display="flex" alignItems="center" gap={1}>
                <Typography variant="caption" color="text" fontFamily={properties.fontFamily}>
                  IFSC :&nbsp;
                  <Typography
                    variant="caption"
                    fontWeight="medium"
                    fontFamily={properties.fontFamily}
                  >
                    {details ? details.ifsc : "NA"}
                  </Typography>
                </Typography>
              </MDBox>
            </Grid>

            <Grid item xs={12} sm={3}>
              <MDBox display="flex" alignItems="center" gap={1}>
                <MDTypography variant="caption" color="text">
                  MICR :&nbsp;
                  <MDTypography variant="caption" fontWeight="medium">
                    {details ? details.micr : "NA"}
                  </MDTypography>
                </MDTypography>
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
    </MDBox>
  );
}

Bill_Bank.defaultProps = {
  noGutter: false
};

Bill_Bank.propTypes = {
  name: PropTypes.string.isRequired,
  company: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  vat: PropTypes.string.isRequired,
  noGutter: PropTypes.bool
};

export default Bill_Bank;
